import React, { FC } from 'react'

import { IconSocialGooglePlusProps } from './IconSocialGooglePlus.types'
import * as Styled from './styles/IconSocialGooglePlus.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialGooglePlus: FC<IconSocialGooglePlusProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialGooglePlusProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSocialGooglePlusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M50 69v21h28.46a27.17 27.17 0 0 1-5.07 8.66 29.66 29.66 0 1 1-3.48-41.8L84.7 42.22a50.51 50.51 0 1 0-34 87.78 45.09 45.09 0 0 0 10.36-1 50.64 50.64 0 0 0 39-60zm109 14.8V71h-17V53h-13v18h-17v13h17v18h13V84h18l-1-.2z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSocialGooglePlus
